export default __webpack_public_path__ + "6c5178d4fd337181c3a2fa152e6e8e3d.svg";